if (!customElements.get('video-loader')) {
  customElements.define('video-loader', class VideoLoader extends HTMLElement {
    constructor() {
      super();

      this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), {
        root: null, // Use the viewport as the root
        threshold: 0.5, // Trigger when 50% of the element is visible
      });
    }

    connectedCallback() {
      this.observeVideos();
    }

    // Define a function to observe videos within the custom element and load them when they become visible
    observeVideos() {
      const videos = this.querySelectorAll('video');

      videos.forEach((video) => {
        this.intersectionObserver.observe(video);

        video.setAttribute('data-paused', 'false')

        video.addEventListener('pause', (event) => {
          video.setAttribute('data-paused', 'true')
        });
      });
    }

    // Handle the intersection changes (when videos become visible/invisible)
    handleIntersection(entries, observer) {
      entries.forEach((entry) => {
        const video = entry.target;

        if (entry.isIntersecting) {
          const sources = video.querySelectorAll("source[data-src]");

          sources.forEach((source) => {
            source.src = source.getAttribute("data-src");
          });

          if(video.getAttribute('data-paused') == 'false'){
            video.load();
          } else {
            if(entry.target.getAttribute("autoplay") === 'autoplay'){
              video.setAttribute('data-paused', 'false')
              video.play();
            }
          }
          
          video.onloadeddata = function() {
            if(entry.target.getAttribute("autoplay") === 'autoplay'){
              video.setAttribute('data-paused', 'false')
              video.play();
            }
          }
          // Unobserve the video once it's loaded
          // observer.unobserve(video);
        } else {
          video.pause();
        }
      });
    }

    // Clean up the Intersection Observer when the element is removed from the DOM
    disconnectedCallback() {
      this.intersectionObserver.disconnect();
    }
  });
}

if (!customElements.get('video-controls')) {
  customElements.define('video-controls', class VideoControls extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.setupControls();
    }

    setupControls() {
      const videoSelector = this.getAttribute('video-selector');
      this.video = this.closest('video-loader')?.querySelector(videoSelector);

      if (!this.video) return;

      const playPauseBtn = this.querySelector(".playPauseBtn");
      const muteBtn = this.querySelector(".muteBtn");
      const playIcon = playPauseBtn.querySelector(".icon-play");
      const pauseIcon = playPauseBtn.querySelector(".icon-pause");
      const muteIcon = muteBtn.querySelector(".icon-mute");
      const unmuteIcon = muteBtn.querySelector(".icon-unmute");

      this.fullscreenBtn = this.querySelector(".fullscreenBtn");
      this.expandIcon = this.fullscreenBtn?.querySelector(".icon-expand");
      this.progress = this.querySelector("progress");

      playPauseBtn.addEventListener("click", () => {
        if (this.video.paused) {
          this.video.play();
        } else {
          this.video.pause();
        }
        this.updatePlayPauseIcons(this.video, playIcon, pauseIcon);
      });

      muteBtn.addEventListener("click", () => {
        this.updateMuteIcons(this.video, muteIcon, unmuteIcon);
      });

      // Update progress bar as the video plays
      if(this.progress){
        this.video.addEventListener("timeupdate", () => {
          const currentValue = (this.video.currentTime / this.video.duration) * 100;
          this.progress.value = currentValue;
        });

        this.progress.addEventListener("click", (event) => {
          const rect = this.progress.getBoundingClientRect();
          const offsetX = event.clientX - rect.left;
          const percentage = offsetX / rect.width;
          this.video.currentTime = percentage * this.video.duration;
      });
      }
      // Seek video when clicking on the progress bar

      
      // Fullscreen toggle functionality
      if (this.fullscreenBtn && this.expandIcon) {
        this.fullscreenBtn.addEventListener("click", () => {
          if (!document.fullscreenElement) {
            this.parentElement.requestFullscreen?.();
          } else {
            document.exitFullscreen?.();
          }
        });
        
        // // Update fullscreen icon when fullscreen changes
        document.addEventListener("fullscreenchange", () => {
          if (document.fullscreenElement) {
            this.expandIcon.classList.replace("icon-expand", "icon-collapse");
          } else {
            this.expandIcon.classList.replace("icon-collapse", "icon-expand");
          }
        });
      }
    }

    // Update the play/pause icon based on video state
    updatePlayPauseIcons(video, playIcon, pauseIcon) {
      if (video.paused) {
        playIcon.style.display = "inline";
        pauseIcon.style.display = "none";
      } else {
        playIcon.style.display = "none";
        pauseIcon.style.display = "inline";
      }
    }

    // Update the mute/unmute icon based on video state
    updateMuteIcons(video, muteIcon, unmuteIcon) {
      if (video.muted) {
        muteIcon.style.display = "none";
        unmuteIcon.style.display = "inline";
      } else {
        muteIcon.style.display = "inline";
        unmuteIcon.style.display = "none";
      }

      video.muted = !video.muted;
    }
  });
}

